/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view/shop.view.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {AppPageTitleService} from '../../../../services/app.page-title.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppKeyValueStorageService} from '../../../../services/app.key-value-storage.service';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {View} from '../../../../models/view';
import {AppViewService} from '../../../../services/app.view.service';
import {Artikel} from '../../../../models/artikel';
import {ArtikelAktion} from '../../../../models/artikel-aktion';
import {ArtikelWithAktionen} from '../../../../models/artikel-with-aktionen';
import {AppSettingsService} from '../../../../services/app.app_settings.service';
import {AppEventService} from '../../../../services/app.event.service';
import {DomainVertreterConfig} from '../../../../models/domain-vertreter-config';
import {AppNavbarService} from '../../../../services/app.navbar.service';
import {ShopViewActionComponent} from '../view-action/shop.view-action.component';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppWarenkorbFlightService} from '../../../../services/app.warenkorb-flight.service';
import {AppShopService} from '../../../../services/app.shop.service';
import {MatDrawer, MatDrawerContainer} from '@angular/material/sidenav';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {ShopViewFilterBottomsheetComponent} from '../view-filter-bottomsheet/shop.view-filter-bottomsheet.component';
import {AppLayoutsFullheightComponent} from '../../../../components/layouts/app.layouts.fullheight.component';
import {AppLieferkundeService} from '../../../../services/app.lieferkunde.service';
import {AppMessageService} from '../../../../services/app.message.service';
import {MatomoTracker} from '../../../matamo/service/matomo-tracker.service';
import {takeUntil} from 'rxjs/operators';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {AppAsyncTimeout} from '../../../../helpers/app.asyncTimeout';
import {ShopViewInterface} from '../../interfaces/shop.view-interface';
import {AppMemoryService} from '../../../../services/app.memory.service';
import {MatDialog} from '@angular/material/dialog';
import {ShopDialogsScan2warenkorbComponent} from '../../dialogs/scan2warenkorb/shop.dialogs.scan2warenkorb.component';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {AppArtikelAktionenService} from '../../../../services/app.artikel-aktionen.service';
import {ShopEinkaufsstatistikwebInterface} from '../../interfaces/shop.einkaufsstatistikweb-interface';
import {ShopAktionenInterface} from '../../interfaces/shop.aktionen-interface';

/**
 * Zweck: Beschreibt class ShopViewComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'shop.view.component.html',
    styleUrls: ['shop.view.component.scss'],
    standalone: false
})
export class ShopViewComponent extends AppLayoutsFullheightComponent implements ShopViewInterface,
            ShopEinkaufsstatistikwebInterface, ShopAktionenInterface, OnInit, OnDestroy {
  static id = 'ShopViewComponent';
  slug: string;
  view = new BehaviorSubject<View>(null);

  sub_route_active = false;

  drawer_state_opened = new BehaviorSubject<boolean>(true);

  loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  total_count = new BehaviorSubject<number>(0);
  count = new BehaviorSubject<number>(0);

  entries = new BehaviorSubject<Artikel[]>(null);

  visible_artikel_aktionen = new BehaviorSubject<any>({});
  visible_artikel_einkaufsstatistik = new BehaviorSubject<any>({});

  vertreterconfig: BehaviorSubject<DomainVertreterConfig> = new BehaviorSubject<DomainVertreterConfig>(null);

  queue = [];

  queue_running = false;

  isMobile = new BehaviorSubject<boolean>(false);

  fsize = 'font-size-1';

  search = '';
  queryParamsearch: undefined;

  layout = new BehaviorSubject<string>('table');
  layoutMobile = new BehaviorSubject<string>('box');
  page_number = 1;
  page_size_1 = 20;

  default_show_elements = 20;

  scrollload_done = false;

  active_filters: string[] = [];

  _destroy = new Subject();

  change_timeout: any;

  saveSearchAndFilter = true;

  @ViewChild('view_scrollbox', {static: false}) scrollbox: any;

  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;

  @ViewChild('drawer', {read: ElementRef})
  /** Aktualisiert den Inhaltsrand, sobald die Drawer-Breite feststeht oder sich ändert. */
  set drawerElement(element: ElementRef<HTMLElement>) {
    this.drawerResizeObserver?.disconnect();
    if (element) {
      this.drawerResizeObserver = new ResizeObserver(() => {
        this.drawerContainer?.updateContentMargins();
      });
      this.drawerResizeObserver.observe(element.nativeElement);
    }
  }

  private drawerResizeObserver: ResizeObserver;

  @ViewChild('filterbox') filterbox: ElementRef;

  actioncomps: ShopViewActionComponent[] = [];

  current_viewscroll_height = new BehaviorSubject<any>(null);

  default_viewscroll_height = 0;

  resize_timeout: any;

  show_warning = new BehaviorSubject<boolean>(false);

  entriesToAdd = [];
  addWorkerRunning = false;

  addWorkerTimeout: any;

  nextAfterNextPage = false;

  autoNextLoadTimeout: any;

  showAktionenDefault = false;
  showEinkaufsstatitikWebDefault = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private route: ActivatedRoute, private vsvc: AppViewService, private router: Router,
              private tsvc: AppPageTitleService, private kvstorage: AppKeyValueStorageService,
              private settsvc: AppSettingsService, private esvc: AppEventService, private nbsvc: AppNavbarService,
              private cd: ChangeDetectorRef, private ssvc: AppShopService, private bottomsheet: MatBottomSheet,
              private msvc: AppMobileService, private memsvc: AppMemoryService, private dialog: MatDialog,
              private wksvc: AppWarenkorbService, private artikelAktionenService: AppArtikelAktionenService,
              private lksvc: AppLieferkundeService, private msg: AppMessageService, private tracker: MatomoTracker,
              private flight: AppWarenkorbFlightService) {
    super();
  }


/**
 * Beschreibt Methode startScan2Warenkorb und ihren Rückgabevertrag.
 */
  startScan2Warenkorb() {
    const ref = this.dialog.open(ShopDialogsScan2warenkorbComponent,
      {
        data: {
          warenkorbId: this.wksvc.primary_warenkorb.value.id,
        }
      });
  }

/**
 * Beschreibt Methode showWarning und ihren Rückgabevertrag.
 */
  showWarning(state: boolean) {
    this.show_warning.next(state);
  }

/**
 * Beschreibt Methode subRouteActivate und ihren Rückgabevertrag.
 */
  subRouteActivate() {
    this.sub_route_active = true;
  }

/**
 * Beschreibt Methode focusNextMenge und ihren Rückgabevertrag.
 */
  focusNextMenge(called_elem) {
    const idx = this.actioncomps.indexOf(called_elem);
    if (this.actioncomps[idx + 1]) {
      this.actioncomps[idx + 1].focusMenge();
    }
  }

/**
 * Beschreibt Methode subRouteDeactivate und ihren Rückgabevertrag.
 */
  subRouteDeactivate() {
    this.sub_route_active = false;
    if (this.view.value) {
      this.tsvc.setTitle('Shop - ' + this.view.value.getLabel());
    }
  }

  @HostListener('window:resize', ['$event'])
/**
 * Beschreibt Methode detectHeight und ihren Rückgabevertrag.
 */
  detectHeight(event) {

    if (this.scrollbox && this.scrollbox.elRef && this.filterbox && this.filterbox.nativeElement) {
      this.current_viewscroll_height.next(null);
      this.detectChanges();
      if (this.resize_timeout) {
        clearTimeout(this.resize_timeout);
      }
      this.resize_timeout = setTimeout(() => {
        if (this.scrollbox.elRef.nativeElement.offsetHeight !== undefined) {
          this.default_viewscroll_height = this.scrollbox.elRef.nativeElement.offsetHeight;
        }

        // const height = this.filterbox.nativeElement.offsetHeight + 27;
        const height = this.filterbox.nativeElement.offsetHeight + 7;
        const new_height = this.default_viewscroll_height - height;
        if (this.current_viewscroll_height.value !== new_height) {
          this.current_viewscroll_height.next(new_height);
          this.detectChanges();
        }
      }, 1500);
    }
  }

/**
 * Beschreibt Methode resetsearch und ihren Rückgabevertrag.
 */
  resetsearch() {
    this.active_filters = [];
    const v = this.view.value;
    v.setActiveFilterKnotenIds(this.active_filters);
    this.view.next(v);
    this.query();
  }

/**
 * Beschreibt Methode showFilter und ihren Rückgabevertrag.
 */
  showFilter() {
    this.bottomsheet.open(ShopViewFilterBottomsheetComponent, {
      data: this
    });

  }

/**
 * Beschreibt Methode openDrawer und ihren Rückgabevertrag.
 */
  openDrawer() {
    this.drawer_state_opened.next(true);
    this.saveView();
  }

/**
 * Beschreibt Methode closeDrawer und ihren Rückgabevertrag.
 */
  closeDrawer() {
    this.drawer_state_opened.next(false);
    this.saveView();
  }

/**
 * Beschreibt Methode registerViewActionComponent und ihren Rückgabevertrag.
 */
  registerViewActionComponent(comp: ShopViewActionComponent) {
    this.actioncomps.push(comp);
  }

/**
 * Beschreibt Methode unregisterViewActionComponent und ihren Rückgabevertrag.
 */
  unregisterViewActionComponent(comp: ShopViewActionComponent) {
    const idx = this.actioncomps.indexOf(comp);
    this.actioncomps.splice(idx, 1);
  }

/**
 * Beschreibt Methode addAll und ihren Rückgabevertrag.
 */
  addAll(exec_after = null) {
    const obs = new Observable(obs => {
      const entries = [];
      const originsByEntry = new Map<WarenkorbEntry, Array<{x: number, y: number}>>();
      this.actioncomps.forEach(c => {
        if (c.entry.menge > 0) {
          entries.push(c.entry);
          originsByEntry.set(c.entry, c.editcomp?.getPositiveMengenOrigins() || []);
        }
      });
      if (entries.length > 0) {
        this.ssvc.addMultiToPrimaryWarenkorb(entries, (addedEntries: WarenkorbEntry[] = []) => {
          const origins = addedEntries.flatMap(entry => originsByEntry.get(entry) || []);
          if (origins.length > 0) {
            this.flight.flyFrom(origins);
          }
          obs.next(addedEntries.length > 0);
          obs.complete();
        });
      } else {
        obs.next(false);
        obs.complete();
      }
    });

    obs.subscribe(s => {
      if (exec_after) {
        AppAsyncTimeout.setTimeout(() => {
          exec_after(s);
        }, 500);
      }
    });
  }

/**
 * Beschreibt Methode saveView und ihren Rückgabevertrag.
 */
  saveView() {
    if (this.saveSearchAndFilter) {
      this.kvstorage.save4User('ShopViewComponent_' + this.slug + '_view', {
        active_filters: this.active_filters,
        search: this.search,
        layout: this.layout.value,
        layoutMobile: this.layoutMobile.value,
        ajax_wk_opened: this.drawer_state_opened.value
      }).subscribe();
    }
  }

/**
 * Beschreibt Methode loadView und ihren Rückgabevertrag.
 */
  loadView(exec_after = null) {
    if (this.saveSearchAndFilter) {
      this.kvstorage.load4User('ShopViewComponent_' + this.slug + '_view').subscribe(last_settings => {
        if (last_settings) {
          this.active_filters = last_settings.active_filters;
          this.search = last_settings.search;
          if (last_settings.ajax_wk_opened) {
            this.drawer_state_opened.next(true);
          } else {
            this.drawer_state_opened.next(false);
          }
          this.layout.next(last_settings.layout);
          if (last_settings.layoutMobile) {
            this.layoutMobile.next(last_settings.layoutMobile);
          }
          const v = this.view.value;
          v.setActiveFilterKnotenIds(this.active_filters);
          this.view.next(v);

          if (exec_after) {
            exec_after(true);
          }

        } else {
          if (exec_after) {
            exec_after(false);
          }
        }
      });
    } else {
      exec_after(false);
    }
  }

/**
 * Beschreibt Methode setBoxLayout und ihren Rückgabevertrag.
 */
  setBoxLayout() {
    if (this.isMobile.value) {
      this.layoutMobile.next('box');
    } else {
      this.layout.next('box');
    }
    this.saveView();
  }

/**
 * Beschreibt Methode setTableLayout und ihren Rückgabevertrag.
 */
  setTableLayout() {
    if (this.isMobile.value) {
      this.layoutMobile.next('table');
    } else {
      this.layout.next('table');
    }
    this.saveView();
  }

/**
 * Beschreibt Methode changePageSize und ihren Rückgabevertrag.
 */
  changePageSize() {
    this.page_number = 1;
    this.query();
  }

/**
 * Beschreibt Methode nextPage und ihren Rückgabevertrag.
 */
  nextPage(silent= false) {
    const pageSize = this.page_size_1;
    if (!this.scrollload_done) {
      if ((this.page_number * pageSize) < this.total_count.value) {
        this.page_number++;
        this.query(true, silent);
      }
    }
  }

/**
 * Beschreibt Methode cancelAddWorker und ihren Rückgabevertrag.
 */
  cancelAddWorker() {
    if (this.addWorkerTimeout) {
      clearTimeout(this.addWorkerTimeout);
    }
    this.entriesToAdd = [];
    this.addWorkerRunning = false;
  }

/**
 * Beschreibt Methode addWorker und ihren Rückgabevertrag.
 */
  addWorker(force= false) {
    if (this.entriesToAdd.length > 0 && (!this.addWorkerRunning || force)) {
      this.addWorkerRunning = true;
      const e = this.entriesToAdd.shift();

      this.entries.next([...this.entries.value, e]);

      if (this.entriesToAdd.length > 0) {
        this.addWorkerTimeout = setTimeout(() => {
          this.addWorker(true);
        });
      } else {
        this.addWorkerRunning = false;
      }
    }
  }

/**
 * Beschreibt Methode changePageNumber und ihren Rückgabevertrag.
 */
  changePageNumber() {
    this.query();
  }

/**
 * Beschreibt Methode showEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  showEinkaufsStatistikWeb(artikel: Artikel) {
    const statRegistry = this.visible_artikel_einkaufsstatistik.value;
    statRegistry[artikel.Artikelstamm + artikel.ArtikelNummer] = artikel.EinkaufsStatistikWeb;
    this.visible_artikel_einkaufsstatistik.next(statRegistry);
  }


/**
 * Beschreibt Methode hideEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  hideEinkaufsStatistikWeb(artikel: Artikel) {
    const statRegistry = this.visible_artikel_einkaufsstatistik.value;
    delete statRegistry[artikel.Artikelstamm + artikel.ArtikelNummer];
    this.visible_artikel_einkaufsstatistik.next(statRegistry);
  }

/**
 * Beschreibt Methode showAktion und ihren Rückgabevertrag.
 */
  showAktion(artikel: Artikel, aktionen: ArtikelAktion[]) {
    const a = new ArtikelWithAktionen();
    a.artikel = artikel;
    a.aktionen = aktionen;
    const aktionenRegistry = this.visible_artikel_aktionen.value;
    aktionenRegistry[artikel.Artikelstamm + artikel.ArtikelNummer] = a;
    this.visible_artikel_aktionen.next(aktionenRegistry);
  }

/**
 * Beschreibt Methode hideAktionen und ihren Rückgabevertrag.
 */
  hideAktionen(artikel: Artikel) {
    const aktionenRegistry = this.visible_artikel_aktionen.value;
    delete aktionenRegistry[artikel.Artikelstamm + artikel.ArtikelNummer];
    this.visible_artikel_aktionen.next(aktionenRegistry);
  }

/**
 * Beschreibt Methode query und ihren Rückgabevertrag.
 */
  query(add_content = false, silent = false) {
    if (this.autoNextLoadTimeout) {
      clearTimeout(this.autoNextLoadTimeout);
    }
    const pageSize = this.page_size_1;

    if (this.search == '' && !this.view.value.settings.allow_empty_search) {
      this.cancelAddWorker();
      this.entries.next(null);
    } else {
      if (!add_content) {
        this.scrollload_done = false;
        this.page_number = 1;
        if (this.scrollbox && this.scrollbox.SimpleBar) {
          this.scrollbox.SimpleBar.getScrollElement().scrollTop = 0;
        }

        this.tracker.trackSiteSearch(this.search, 'view_' + this.view.value.slug);
        this.cancelAddWorker();
      }
      this.saveView();
      if (!silent) { this.loading.next(true); }
      this.vsvc.queryBySlug(this.slug, this.page_number, pageSize, this.active_filters, this.search).subscribe({
        next: (res) => {
          if (this.view.value.settings.allow_empty_search == false && this.search == '') {
            this.cancelAddWorker();
            this.entriesToAdd = res.data;
            this.entries.next([]);
            this.addWorker();
            this.count.next(res.count);
          } else {
            if (add_content) {
              if (res.data.length == 0 || res.data.length < pageSize) {
                this.scrollload_done = true;
              }

              if (this.entries.value) {
                res.data.forEach(d => {
                  this.entriesToAdd.push(d);
                });
                this.addWorker();
              } else {
                this.cancelAddWorker();
                this.entriesToAdd = res.data;
                this.entries.next([]);
                this.addWorker();
              }

              this.count.next(this.count.value + res.count);

            } else {
              this.entries.next(res.data);
              this.count.next(res.count);
            }
          }

          if (!add_content || !isNaN(res.total_count)) {
            this.total_count.next(res.total_count);
          }

          if (this.count.value < this.default_show_elements && res.total_count > this.count.value) {
            this.autoNextLoadTimeout = setTimeout(() => {
              this.nextPage(true);
            }, 500);
          }

          if (this.nextAfterNextPage) {
            this.nextAfterNextPage = false;
            this.nextPage();
          }

          if (!silent) { this.loading.next(false); }
        },
        error: (err) => {
          if (!silent) { this.loading.next(false); }
          this.entries.next([]);
          this.count.next(0);
        }
      });
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this.drawerResizeObserver?.disconnect();
    this.tsvc.resetTitle();

    this.nbsvc.resetColors();
    this.nbsvc.clear();

    this._destroy.next(true);
    this._destroy.complete();
  }

/**
 * Beschreibt Methode doChange und ihren Rückgabevertrag.
 */
  doChange() {
    this.active_filters = this.view.value.getActiveFilterKnotenIds();
    if (this.change_timeout) {
      clearTimeout(this.change_timeout);
    }
    this.change_timeout = setTimeout(() => {
      this.query();
    }, 2000);
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.msvc.isMobile().pipe(takeUntil(this._destroy)).subscribe(m => {
      if (this.isMobile.value != m) {
        this.isMobile.next(m);
        this.detectChanges();
      }
    });
    this.vsvc.$vertreterconfig
      .pipe(takeUntil(this._destroy))
      .subscribe(c => {
      this.vertreterconfig.next(c);
      this.detectChanges();
    });

    this.settsvc.getUserSettingValue('ShopOpenAktionenPerDefault').subscribe({next: (state) => {
        if (state) {
          this.showAktionenDefault = true;
        }
      },
      error: (err) => {

      }
    });

    this.settsvc.getUserSettingValue('ShopOpenEKStatWebPerDefault').subscribe({next: (state) => {
        if (state) {
          this.showEinkaufsstatitikWebDefault = true;
        }
      },
      error: (err) => {

      }
    });

    this.esvc.getQueue()
      .pipe(takeUntil(this._destroy))
      .subscribe(e => {
        if (e.name == 'gui.ShopCustomerSpecialPriceChanged') {
          this.query();
        } else if (e.name == 'gui.globalSearchResultClicked') {
          this.init();
        }
    });

    this.route.params
      .pipe(takeUntil(this._destroy))
      .subscribe(p => {
        this.slug = p['slug'];
        this.loadSettings(() => {
          this.init();
        });
    });

    this.route.queryParams
      .pipe(takeUntil(this._destroy))
      .subscribe(p => {
        if (p && p['search']) {
          if (this.entries.value) {
            this.search = p['search'];
            this.query();
          } else {
            this.queryParamsearch = p['search'];
          }
        }
    });
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

  private initScrollBox() {
    if (this.scrollbox && this.scrollbox.SimpleBar) {
      this.scrollbox.SimpleBar.getScrollElement().addEventListener('scroll', (e) => {
        const scrollheight = e.target.scrollTop + e.target.offsetHeight;

        const pageheight = e.target.offsetHeight - 50;

        const load_border = pageheight * (this.page_number - 1) + (pageheight * 0.3);

        if (scrollheight > load_border) {
          if (!this.loading.value) {
            this.nextPage();
          } else {
            this.nextAfterNextPage = true;
          }
        } else {

        }
      });
      this.detectHeight(null);
    } else {
      AppAsyncTimeout.setTimeout(() => {
        this.initScrollBox();
      }, 200);
    }
  }

  private loadSettings(exec_after_ready) {
    const obs = new BehaviorSubject(0);
    this.settsvc.getUserSettingValue('ShopSaveSearchAndFilter').subscribe(s => {
      this.saveSearchAndFilter = s;
      obs.next(obs.value + 1);
    });

    this.settsvc.getUserSettingValue('ShopViewArticleFontSize').subscribe(s => {
      switch (s) {
        case 1:
          this.fsize = 'font-size-1';
          break;
        case 2:
          this.fsize = 'font-size-2';
          break;
        case 3:
          this.fsize = 'font-size-3';
          break;
        case 4:
          this.fsize = 'font-size-4';
          break;
        case 5:
          this.fsize = 'font-size-5';
          break;
        default:
          this.fsize = 'font-size-1';
      }
      obs.next(obs.value + 1);
    });

    const sub = obs.subscribe(v => {
      if (v == 2) {
        exec_after_ready();
        sub.unsubscribe();
      }
    });
  }
  private init() {
    // this.loader.start('ShopViewComponent_1', 'Shop wird geladen!');

    this.vsvc.getBySlug(this.slug).subscribe({next: (v) => {
      if (v) {
        if (this.lksvc.current_differential_lieferkunde.value && !v.settings.different_lieferkunde_mode) {
          this.msg.error('Im Lieferung für Modus nicht verfügbar!');
          this.nbsvc.triggerBack();
        }
        this.nbsvc.setFontColor(v.settings.font_color);
        this.nbsvc.setBGColor(v.settings.bg_color);
        this.nbsvc.setBGLinkColor(v.settings.bg_link_color);
        this.nbsvc.setInversedLogo(v.settings.logo_inversed);
        this.nbsvc.setLabel(v.getLabel());
        this.view.next(v);
        this.tsvc.setTitle('Shop - ' + v.getLabel());
        AppAsyncTimeout.setTimeout(() => {
          this.initScrollBox();
        }, 300);
        // this.loader.stop('ShopViewComponent_1');
        this.loadView((had_query) => {
          if (this.queryParamsearch) {
            this.search = this.queryParamsearch;
            this.active_filters = [];
            this.queryParamsearch = undefined;
          }

          let hadShopSearch = false;

          if (this.memsvc.has('shopSearch')) {
            this.search = this.memsvc.get('shopSearch');
            this.memsvc.delete('shopSearch');
            hadShopSearch = true;
          }

          if (this.view.value.settings.allow_empty_search || had_query || hadShopSearch) {
            this.query();
          }
        });
      } else {
        this.router.navigateByUrl('/error/not-found', {replaceUrl: true});
      }
    }, error: (error) => {

    }
    });
  }


}
